module.exports = __webpack_public_path__ + "static/media/pricing.c5248390.jpg";